// eslint-disable-next-line
const log = console.log

export default log
